export default __webpack_public_path__ + "static/media/arExperienceBackground.866fa846.svg";